import React from "react"
import PropTypes from "prop-types"
import { Container } from "./styles"
import { P } from "../../typography"
import Button from "../../button"

const SubmitButton = ({ text, additionalText, backButton, backButtonOnly, backButtonText, simpleForm, ...rest }) => {
  let propsForButton = {
    type: rest.type,
    disabled: rest.disabled,
    onClick: rest.handleClick,
    to: rest.to,
    href: rest.href,
    variant: simpleForm ? "simpleForm" : rest.variant
  }
  let propsForBackButton = {
    ...backButton,
    onClick: backButton?.handleClick,
    disabled: rest.disabled && !rest.ignoreDisabledForBackButton
  }

  return (
    <Container simpleForm={simpleForm}>
      {additionalText && (
        <P
          variant={simpleForm ? "content" : "secondaryReadable"}
          marginless
          bold
          align="center"
          className="additional-text"
        >
          {additionalText}
        </P>
      )}
      {backButton && (
        <Button variant={simpleForm ? "simpleFormBack" : "white"} outlined {...propsForBackButton}>
          {backButtonText}
        </Button>
      )}
      {!backButtonOnly && (
        <Button {...propsForButton} actionButton={additionalText?.length > 0 ? false : true}>
          {text}
        </Button>
      )}
    </Container>
  )
}

SubmitButton.propTypes = {
  type: PropTypes.oneOf(["button", "submit"]),
  text: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired,
  handleClick: PropTypes.func,
  to: PropTypes.string,
  href: PropTypes.string,
  simpleForm: PropTypes.bool,
  additionalText: PropTypes.string,
  variant: PropTypes.oneOf(["default", "primary", "secondary", "white", "success", "danger"]),
  backButton: PropTypes.shape({
    handleClick: PropTypes.func,
    to: PropTypes.string,
    href: PropTypes.string
  }),
  backButtonText: PropTypes.string,
  backButtonOnly: PropTypes.bool.isRequired,
  ignoreDisabledForBackButton: PropTypes.bool
}

SubmitButton.defaultProps = {
  type: "submit",
  text: "Save",
  disabled: false,
  handleClick: undefined,
  to: null,
  href: null,
  additionalText: null,
  variant: "success",
  backButton: null,
  backButtonOnly: false,
  backButtonText: "Back",
  ignoreDisabledForBackButton: false
}

export default SubmitButton
